export default __webpack_public_path__ + "static/villa2-fe55e1fda7910546ddb3a3b3beff7972.jpeg";